<template>
  <div class="home" style="width: 100%; height: 100%">
    <div style="width: 60.36vw; height: 36.46vw" ref="main"></div>
    <p
      style="
        font-size: 16px;
        font-weight: normal;
        line-height: 1.56vw;
        height: 1.56vw;
        text-align: center;
        margin-top: 1.04vw;
        text-align: center;
        color: #6d6d6d;
      "
    >
      *地图经过变形处理，仅供参考。
    </p>
  </div>
</template>
<script>
//获取中国地图的json数据
import * as echarts from "echarts";
import worldJson from "../assets/json/world.json";
export default {
  mounted() {
    let that = this;
    let mychinachart = echarts.init(this.$refs.main);

    echarts.registerMap("world", worldJson);

    var geoCoordMap = {
      阿联酋: [54.2212, 24.2812],
      摩洛哥: [101.682591, 23.431461],
      匈牙利: [19.05, 47.29],
    };
    var data = [
      { name: "阿联酋", value: "阿联酋阿提哈德常规快速客运线沿线车站项目" },
      {
        name: "摩洛哥",
        value: "欣捷安汽车电子摩洛哥有限公司摩洛哥基地(一期)建设工程项目",
      },
      { name: "匈牙利", value: "比亚迪牙利PACK厂房改造项目" },
    ];

    var convertData = function (data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var geoCoord = geoCoordMap[data[i].name];
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value),
          });
        }
      }
      return res;
    };
    const option = {
      grid: {
        // 设置图表距离顶部,左侧，右侧和底部的高度
        top: "20px",
        left: "20px",
        right: "20px",
        bottom: "40px",
      },
      tooltip: {
        //提示框
        enterable: true,
        // 触发方式 mousemove, click, none, mousemove|click
        triggerOn: "click",
        // item 图形触发， axis 坐标轴触发， none 不触发
        trigger: "item",
        backgroundColor: "rgb(255,255,255,1)",
        show: true,
        position: (point, params, dom, rect, size) => {
          return [
            point[0] - dom.clientWidth / 2,
            point[1] - size.contentSize[1] - 25,
          ];
        },
        extraCssText:
          "white-space:unset;box-shadow: none;word-break:break-all;word-wrap:break-word;border:none;padding:0;width:11.46vw;height:60px;", // 额外样式
        formatter: function (params) {
          console.log(params);
          return `<div style='position:relative'>
          <p style=" width:100%;height:100%;word-break:break-all;word-wrap:break-word;padding:7px 9px 6px 9px;text-align:center" class="tooltips">
        ${params.value[2]}
                  </p>
                  <div style="position: absolute; bottom: -14px; left: calc(50% - 8px); width: 0; height: 0; overflow: hidden; border-width: 8px; border-color: #ffffff transparent transparent transparent; border-style: dashed dashed solid dashed;}"></div>

                  </div>`;
        },
      },

      geo: {
        map: "world",
        show: true,
        roam: true,
        zoom: 1.3,
        center: [0, 0], //地图中心点经纬度坐标
        itemStyle: {
          normal: {
            areaColor: "#9ECAF5",
            borderColor: "#fff", // 线
          },
          emphasis: {
            // 也是选中样式
            borderWidth: 2,
            borderColor: "#fff",
            areaColor: "rgba(3, 94, 190, .6)", //悬浮区背景
          },
        },
        emphasis: {
          label: { show: false },
        },
      },
      series: [
        {
          name: "Top5",
          type: "scatter",
          coordinateSystem: "geo",
          symbol: "image://" + require("../assets/image/point.png"), // 自定图标点图标
          symbolSize: [30, 30],
          data: convertData(data),
          emphasis: { label: { show: false } },
        },
      ],
    };
    mychinachart.setOption(option);
   
  },
};
</script>
